import { useMutation } from "@tanstack/react-query";
import { Http } from "./interceptors/http.interceptor";

export const CreateShortLink = (obj) =>
  Http.post(
    `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBmTqvm1uWdYxcx9yKSg0zVlOBMkr8_X_I`,
    obj,
  );

export const useCreateShortLink = () => useMutation(CreateShortLink);